import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './ExportDes.css';

class ExportDes extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      text: '',
      showTextArea: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.editVal = this.editVal.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleChange (e) {
    this.setState({
      text: e.target.value
    })
  }

  editVal () {    
    this.setState({
      showTextArea: true
    });
  }

  handleBlur () {
    this.setState({
      showTextArea: false
    })
  }

  render () {
    return (
      <div className={s.container} onDoubleClick={this.editVal}>
        {
          this.state.showTextArea
          ? <div className={s.inputWrapper}>
              <textarea 
                value={this.state.text}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                className={s.inputElem}
                autoFocus
               />
            </div>
          : ''
        }
        <div className={s.innerText}>
          {this.state.text || this.props.children}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ExportDes);


// WEBPACK FOOTER //
// src/components/ExportDes/ExportDes.js